export const AUTH_INITIALIZED = "AUTH_INITIALIZED";
export const AUTH_FAILED = "AUTH_FAILED";
export const SET_USER = "SET_USER";
export const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_AUTHENTICADED = "SET_AUTHENTICADED";
export const SET_2FA = "SET_2FA";
export const SET_UNFRESH_ACCESS_TOKEN = "SET_UNFRESH_ACCESS_TOKEN";
export const CLEAR_UNFRESH_ACCESS_TOKEN = "CLEAR_UNFRESH_ACCESS_TOKEN";
export const CLEAR_TOKENS = "CLEAR_TOKENS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const CLIENT_ID = process.env.CLIENT_ID;
export const API_HOST = process.env.AUTH_HOST;
import { changePage, loadAuthResources } from "@stofloos/actions/app";

const MINUTES_UNITL_AUTO_LOGOUT = process.env.AUTO_LOGOUT ? process.env.AUTO_LOGOUT : 60;
const CHECK_INTERVAL = process.env.AUTO_LOGOUT_INTERVAL ? process.env.AUTO_LOGOUT_INTERVAL : 60000;
const STORE_KEY = "lastAction";


const postOption = (body, auth) => {
	if(!body) {
		body = {}
	}
	body['client_id'] = CLIENT_ID;
	const headers = {
		"Content-Type": "application/json"
	};

	if(auth) {
		headers['Authorization'] = auth;
	}
	return {
		method: "POST",
		credentials: "include",
		headers: headers,
		body: JSON.stringify(body)
	}
};

export class AutoLogoutService {
	get lastAction() {
		return parseInt(localStorage.getItem(STORE_KEY));
	}

	set lastAction(value) {
		localStorage.setItem(STORE_KEY, value);
	}

	constructor(dispatch, authService) {
		this.auth = authService;
		this.dispatch = dispatch;
		this.check();
		this.initListener();
		this.initInterval();
	}

	initListener() {
		document.body.addEventListener("click", () => this.reset());
	}

	reset() {
		this.lastAction = Date.now();
	}

	initInterval() {
		setInterval(() => {
			this.check();
		}, CHECK_INTERVAL);
	}

	check() {
		const now = Date.now();
		const timeleft = this.lastAction + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
		const diff = timeleft - now;
		const isTimeout = diff < 0;

		if (isTimeout && this.auth.isAuthenticated) {
			localStorage.clear(STORE_KEY);
			this.dispatch(signOut());
		}
	}
}

export const activateAutoLogout = (dispatch, getState) => {
	new AutoLogoutService(dispatch, getState().StofwareAuth);
};

export const isSuccessful = (dispatch, getState) => response => {
	let json = response.clone().json();

	if (response.status >= 200 && response.status < 300) {
		return response;
	} else {
		if (response.json()) {
			return json.then(err => {
				if (
					err.msg &&
					err.msg ===
						'Missing JWT in headers or cookies (Missing cookie "refresh_token_cookie"; Missing Authorization Header)'
				) {
					err.msg = "";
				}
				throw err;
			});
		} else {
			let error = new Error(response.statusText);
			error.response = response;
			throw error;
		}
	}
};

export const checkFetchStatus = (dispatch, getState, request) => response => {
	if (response.status >= 200 && response.status < 300) {
		return response;
	} else if (response.status === 401) {
		return tokenRefresh(dispatch, getState)
			.then(() => {
				//TODO do request again
				return response;
			})
			.catch(e => {
				let error = new Error(response.statusText);
				error.response = response;
				throw error;
			});
	} else {
		let error = new Error(response.statusText);
		error.response = response;
		throw error;
	}
};

export const validAccessToken = () => (dispatch, getState) => {
	const state = getState();
	return new Promise(resolve => {
		if (state.StofwareAuth && state.StofwareAuth.access_token) {
			fetch(`${API_HOST}/token/access`, postOption({}, "Bearer "+state.StofwareAuth.access_token))
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error") {
						dispatch(setAuthenticated(false));
						dispatch(authFail(data));
						resolve();
					} else {
						dispatch(setAuthenticated(true));
						resolve();
					}
				})
				.catch(e => {
					dispatch(authFail(e));
					resolve();
				});
		} else if (state.StofwareAuth && state.StofwareAuth.unfresh_access_token) {
			resolve();
		} else {
			return tokenRefresh(dispatch, getState)
				.then(() => {
					if (getState().StofwareAuth.access_token) {
						dispatch(setAuthenticated(true));
					}
					resolve();
				})
				.catch(e => {
					resolve();
				});
		}
	});
};

/**
 * Called when access token fails (access token invalid or not available).
 */
export const tokenRefresh = (dispatch, getState, refreshToken) => {
	const state = getState();
	return new Promise(function(resolve, reject) {
		fetch(`${API_HOST}/token/refresh`, postOption(null,  refreshToken ? "Bearer " + refreshToken : null))
			.then(isSuccessful(dispatch, getState))
			.then(res => res.json())
			.then(data => {
				if (data.status === "error") {
					dispatch(clearTokens());
					reject();
				} else {
					dispatch(setAccessToken(data.access_token));
					dispatch(setUser(getUserFromAccessToken(data.access_token)));
					resolve();
				}
			})
			.catch(e => {
				dispatch(clearTokens());
				reject();
			});
	});
};

/**
 * Called manually by the user to reset password
 */
export const changePassword = (body, refresh_token) => (dispatch, getState) => {
	const state = getState();
	body["password"] = btoa(body["password"]);
	return new Promise(resolve => {
		fetch(`${API_HOST}/password/reset`, postOption(body, "Bearer " + refresh_token))
			.then(res => res.json())
			.then(data => {
				if (data.status === "error") {
					dispatch(authFail(data));
				} else {
					resolve();
					dispatch(changePage("/login"));
					dispatch(loadAuthResources(window.location));
				}
			})
			.catch(e => dispatch(authFail(e)));
	});
};

/**
 * Called manually by the user to reset password
 */
export const changePassword2FA = (body, refresh_token) => (dispatch, getState) => {
	const state = getState();
	body["password"] = btoa(body["password"]);

	return new Promise(resolve => {
		fetch(`${API_HOST}/password/reset`, postOption(body, "Bearer " + refresh_token))
			.then(res => res.json())
			.then(data => {
				if (data.status === "error") {
					dispatch(authFail(data));
				} else {
					dispatch(changePage("/login"));
					dispatch(loadAuthResources(window.location));
					resolve();
				}
			})
			.catch(e => dispatch(authFail(e)));
	});
};

/**
 * Called manually by the user to forgot password
 */
export const forgotPassword = body => dispatch => {
	fetch(`${API_HOST}/password/forgot`, postOption(body))
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(authFail(data));
			} else {
				dispatch(changePage("/login"));
				dispatch(loadAuthResources(window.location));
			}
		})
		.catch(e => dispatch(authFail(e)));
};

/**
 * Called manually by the user to forgot otp
 */
export const forgotOTP = body => dispatch => {
	body["password"] = btoa(body["password"]);

	fetch(`${API_HOST}/twofactor/lostdevice`, postOption(body))
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(authFail(data));
			} else {
				dispatch(changePage("/login"));
				dispatch(loadAuthResources(window.location));
			}
		})
		.catch(e => dispatch(authFail(e)));
};
/**
 * Called manually by the user to confirm account
 */
export const confirmAccount = confirm_token => dispatch => {
	fetch(`${API_HOST}/account/confirm`, postOption(body, "Bearer " + confirm_token))
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(authFail(data));
			} else {
				dispatch(changePage("/login"));
				dispatch(loadAuthResources(window.location));
			}
		})
		.catch(e => dispatch(authFail(e)));
};

/**
 * Called manually by the user to register
 */
export const registerAccount = body => dispatch => {
	body["user"]["password"] = btoa(body["user"]["password"]);
	fetch(`${API_HOST}/registration`, postOption(body))
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(authFail(data));
			} else {
				dispatch(changePage("/login"));
				dispatch(loadAuthResources(window.location));
			}
		})
		.catch(e => dispatch(authFail(e)));
};
/**
 * Called either manually by the user or when auth token refresh fails (refresh token invalid).
 */
export const signOut = () => (dispatch, getState) => {
	const state = getState();
	fetch(`${API_HOST}/logout/refresh`, postOption())
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(authFail(data));
			} else {
				dispatch(setUser(null));
				dispatch(setAccessToken(null));
				dispatch(clearTokens());
				window.location = "";
			}
		})
		.catch(e => dispatch(authFail(e)));
};

/**
 * Called manually by the user to login 1Factor
 */
export const signIn = body => dispatch => {
	dispatch(authInitialized());
	body["password"] = btoa(body["password"]);
	fetch(`${API_HOST}/login`, postOption(body))
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(setAuthenticated(false));
				dispatch(authFail(data));
			} else if (data.access_token && data.type && data.type === "2fa") {
				// 2FA authentication
				dispatch(setUnFreshAccessToken(data.access_token));
				dispatch(changePage("/2fa"));
				dispatch(loadAuthResources(window.location));
			} else if (data.access_token) {
				// 1FA authentication
				dispatch(setUser(getUserFromAccessToken(data.access_token)));
				dispatch(setAccessToken(data.access_token));
				dispatch(changePage("/home"));
				location.reload(true);
			} else {
				dispatch(setAuthenticated(false));
				dispatch(authFail(data));
			}
		})
		.catch(e => dispatch(authFail(e)));
};

/**
 * Called manually by the user from otp
 * Gets fresh access token & refresh token
 */
export const signInOtp = body => (dispatch, getState) => {
	const state = getState();
	dispatch(authInitialized());
	fetch(`${API_HOST}/twofactor/verify`, postOption(body, "Bearer " + state.StofwareAuth.unfresh_access_token))
		.then(res => res.json())
		.then(data => {
			if (data.status === "error") {
				dispatch(setAuthenticated(false));
				dispatch(authFail(data));
			} else if (data.access_token) {
				dispatch(clearUnfreshToken());
				dispatch(setUser(getUserFromAccessToken(data.access_token)));
				dispatch(setAccessToken(data.access_token));
				dispatch(changePage("/home"));
				location.reload(true);
			} else {
				dispatch(setAuthenticated(false));
				dispatch(authFail(data));
			}
		})
		.catch(e => dispatch(authFail(e)));
};

/**
 * gets QR Code for 2FA user needs refresh token
 * is not connected to te store returns directly the image
 */
export const getOtpQrCodeReset = confirm_token => {
	return new Promise(function(resolve, reject) {
		fetch(`${API_HOST}/twofactor/resetdevice`,  postOption(body, "Bearer " + confirm_token))
			.then(checkFetchStatus())
			.then(response => response.blob())
			.then(blob => {
				const imageUrl = URL.createObjectURL(blob);
				resolve(imageUrl);
			})
			.catch(e => {
				reject();
			});
	});
};

/**
 * gets QR Code for 2FA user needs refresh token
 * is not connected to te store returns directly the image
 */
export const getOtpQrCode = (body, confirm_token) => {
	return new Promise(function(resolve, reject) {
		fetch(`${API_HOST}/twofactor/otpqrcode`,  postOption(body, "Bearer " + confirm_token))
			.then(checkFetchStatus())
			.then(response => response.blob())
			.then(blob => {
				const imageUrl = URL.createObjectURL(blob);
				resolve(imageUrl);
			})
			.catch(e => {
				reject();
			});
	});
};

const getUserFromAccessToken = access_token => {
	const user = JSON.parse(window.atob(access_token.split(".")[1]));
	return user;
};

const authInitialized = () => {
	return {
		type: AUTH_INITIALIZED
	};
};

const authFail = e => {
	return {
		type: AUTH_FAILED,
		error: e
	};
};
const setAccessToken = access_token => {
	return {
		type: SET_ACCESS_TOKEN,
		access_token
	};
};
const setUnFreshAccessToken = unfresh_access_token => {
	return {
		type: SET_UNFRESH_ACCESS_TOKEN,
		unfresh_access_token
	};
};

const setRefreshToken = refresh_token => {
	return {
		type: SET_REFRESH_TOKEN,
		refresh_token
	};
};
const setUser = user => {
	return {
		type: SET_USER,
		user
	};
};
const setAuthenticated = isAuthenticated => {
	return {
		type: SET_AUTHENTICADED,
		isAuthenticated
	};
};

const clearUnfreshToken = () => {
	return {
		type: CLEAR_UNFRESH_ACCESS_TOKEN
	};
};

const clearTokens = () => {
	return {
		type: CLEAR_TOKENS
	};
};

export const clearErrors = () => {
	return {
		type: CLEAR_ERRORS
	};
};
